import React from 'react';
import TeamItem from '../../../components/Homepage/Team/TeamItem';
import {Container, Image} from 'react-bootstrap';
import { ReactComponent as BgImage } from "../../../assets/images/oval-seccao-team.svg";
import img from "../../../assets/images/homepage/section-3/1-tracejado.svg";
import img2 from "../../../assets/images/jobs/section-3/3-tracejado.svg";
import Spinner from '../../UI/Spinner/Spinner';
import { Suspense } from 'react';
const Carousel = React.lazy(() => import('../../UI/Carousel/Carousel'));


const Team = props => {
    const lorena1 = require('../../../assets/images/team/Lorena_1.png');
    const lorena1Webp = require('../../../assets/images/team/Lorena_1.webp');
    const lorena2 = require('../../../assets/images/team/Lorena_2.png');
    const lorena2Webp = require('../../../assets/images/team/Lorena_2.webp');
    const rita_segurado1 = require('../../../assets/images/team/Rita_Segurado_1.png');
    const rita_segurado1Webp = require('../../../assets/images/team/Rita_Segurado_1.webp');
    const rita_segurado2 = require('../../../assets/images/team/Rita_Segurado_2.png');
    const rita_segurado2Webp = require('../../../assets/images/team/Rita_Segurado_2.webp');
    const erica1 = require('../../../assets/images/team/Erica_1.png');
    const erica1Webp = require('../../../assets/images/team/Erica_1.webp');
    const erica2 = require('../../../assets/images/team/Erica_2.png');
    const erica2Webp = require('../../../assets/images/team/Erica_2.webp');
    const goncalo1 = require('../../../assets/images/team/Goncalo_1.png');
    const goncalo1Webp = require('../../../assets/images/team/Goncalo_1.webp');
    const goncalo2 = require('../../../assets/images/team/Goncalo_2.png');
    const goncalo2Webp = require('../../../assets/images/team/Goncalo_2.webp');
    const leonardo1 = require('../../../assets/images/team/Leonardo_1.png');
    const leonardo1Webp = require('../../../assets/images/team/Leonardo_1.webp');
    const leonardo2 = require('../../../assets/images/team/Leonardo_2.png');
    const leonardo2Webp = require('../../../assets/images/team/Leonardo_2.webp');
    const joana1 = require('../../../assets/images/team/Joana_1.png');
    const joana1Webp = require('../../../assets/images/team/Joana_1.webp');
    const joana2 = require('../../../assets/images/team/Joana_2.png');
    const joana2Webp = require('../../../assets/images/team/Joana_2.webp');
    const pedro1 = require('../../../assets/images/team/Pedro_1.png');
    const pedro1Webp = require('../../../assets/images/team/Pedro_1.webp');
    const pedro2 = require('../../../assets/images/team/Pedro_2.png');
    const pedro2Webp = require('../../../assets/images/team/Pedro_2.webp');
    const tiago1 = require('../../../assets/images/team/Tiago_1.png');
    const tiago1Webp = require('../../../assets/images/team/Tiago_1.webp');
    const tiago2 = require('../../../assets/images/team/Tiago_2.png');   
    const tiago2Webp = require('../../../assets/images/team/Tiago_2.webp');

    return(
        <section id="team" className="my"> 
        <Image src={img} className="img-dashed-t  d-none d-lg-block" />

        <BgImage className="backgroundImg" />
            <Container>
            <h2 className="h4 text-center fw-600 black mb-0">
            {props.t("homepage:section-4.title")}
            </h2>
                <Suspense fallback={<Spinner />}>
                    <Carousel className="teamSlide">
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-rita-segurado-1')}
                            quote2={props.t('homepage:section-4.quote-rita-segurado-2')}
                            email="rita.segurado@sysmatch.com"
                            name="Rita Segurado"
                            position="Head of Sales"
                            src1 = {rita_segurado1.default}
                            src1Webp = {rita_segurado1Webp.default}
                            src2 = {rita_segurado2.default}
                            src2Webp = {rita_segurado2Webp.default}
                            alt={props.t('homepage:section-4.rita-segurado_alt')}

                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-pedro-lima-1')}
                            quote2={props.t('homepage:section-4.quote-pedro-lima-2')}
                            email="pedro.lima@sysmatch.com"
                            name="Pedro Lima"
                            position="Business Unit Manager"
                            src1 = {pedro1.default}
                            src1Webp = {pedro1Webp.default}
                            src2 = {pedro2.default}
                            src2Webp = {pedro2Webp.default}
                            alt={props.t('homepage:section-4.pedro-lima_alt')}

                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-tiago-lopes-1')}
                            quote2={props.t('homepage:section-4.quote-tiago-lopes-2')}
                            email="tiago.lopes@sysmatch.com"
                            name="Tiago Lopes"
                            position="Business Unit Manager"
                            src1 = {tiago1.default}
                            src1Webp = {tiago1Webp.default}
                            src2 = {tiago2.default}
                            src2Webp = {tiago2Webp.default}
                            alt={props.t('homepage:section-4.tiago-lopes_alt')}
                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-joana-novais-1')}
                            quote2={props.t('homepage:section-4.quote-joana-novais-2')}
                            email = "joana.novais@sysmatch.com"
                            name="Joana Novais"
                            position="Business Manager"
                            src1 = {joana1.default}
                            src1Webp = {joana1Webp.default}
                            src2 = {joana2.default}
                            src2Webp = {joana2Webp.default}
                            alt={props.t('homepage:section-4.joana-novais_alt')}

                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-lorena-lourenco-1')}
                            quote2={props.t('homepage:section-4.quote-lorena-lourenco-2')}
                            email="lorena.lourenco@sysmatch.com"
                            name="Lorena Lourenço"
                            position="Recruitment Team Leader"
                            src1 = {lorena1.default}
                            src1Webp = {lorena1Webp.default}
                            src2 = {lorena2.default}
                            src2Webp = {lorena2Webp.default}
                            alt={props.t('homepage:section-4.lorena-lourenco_alt')}
                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-leonardo-sousa-1')}
                            quote2={props.t('homepage:section-4.quote-leonardo-sousa-2')}
                            email="leonardo.sousa@sysmatch.com"
                            name="Leonardo Sousa"
                            position="IT Recruiter"
                            src1 = {leonardo1.default}
                            src1Webp = {leonardo1Webp.default}
                            src2 = {leonardo2.default}
                            src2Webp = {leonardo2Webp.default}
                            alt={props.t('homepage:section-4.leonardo-sousa_alt')}

                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-goncalo-rodrigues-1')}
                            quote2={props.t('homepage:section-4.quote-goncalo-rodrigues-2')}
                            email="goncalo.rodrigues@sysmatch.com"
                            name="Gonçalo Rodrigues"
                            position="IT Recruiter"
                            src1 = {goncalo1.default}
                            src1Webp = {goncalo1Webp.default}
                            src2 = {goncalo2.default}
                            src2Webp = {goncalo2Webp.default}
                            alt={props.t('homepage:section-4.goncalo-rodrigues_alt')}
                        />
                        <TeamItem 
                            quote1={props.t('homepage:section-4.quote-erica-figueiredo-1')}
                            quote2={props.t('homepage:section-4.quote-erica-figueiredo-2')}
                            email="erica.figueiredo@sysmatch.com"
                            name="Erica Figueiredo"
                            position="IT Recruiter"
                            src1 = {erica1.default}
                            src1Webp = {erica1Webp.default}
                            src2 = {erica2.default}
                            src2Webp = {erica2Webp.default}
                            alt={props.t('homepage:section-4.erica-figueiredo_alt')}
                        />
                    </Carousel> 
                </Suspense>
            </Container>
            <Image src={img2} className="img-dashed-b d-none d-lg-block" />
        </section>
    );
}

export default Team;
